import React from "react";

const Footer = () => (
  <footer>
    {/* Contenido eliminado */}
  </footer>
);

export default Footer;
